// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import breakpoints from "assets/theme/base/breakpoints";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Loader from "examples/Loader";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";

function AgencyDashboard() {
  const { values } = breakpoints;
  const { company_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();

  const [data, setData] = useState({
    new_sign_up: 0,
    followers: 0,
    claim_requests: 0,
    approved_requests: 0,
    pending_request: 0,
    reviews: 0,
    premium_businesses: 0,
    directory_visits: 0,
  });

  const getDashboardData = async () => {
    const { response } = await AppService.agency.dashboard_data({
      query: `company_id=${company_id}`,
    });
    if (response) {
      setData(response?.data);
    }

    setLoader(false);
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      {/* <DashboardNavbar /> */}
      <SoftBox py={3}>
        <Grid container>
          <Grid item xs={12} lg={12}>
            <SoftBox mb={3} p={1}>
              <SoftTypography
                variant={window.innerWidth < values.sm ? "h3" : "h2"}
                textTransform="capitalize"
                fontWeight="bold"
              >
                general statistics
              </SoftTypography>
            </SoftBox>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Directory Visits", fontWeight: "bold" }}
                    count={data?.directory_visits || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "paid" }}
                  />
                </SoftBox>
                <MiniStatisticsCard
                  bgColor="white"
                  color="dark"
                  title={{ text: "Approved Requests", fontWeight: "bold" }}
                  count={data?.approved_requests || 0}
                  percentage={{ color: "success", text: "" }}
                  icon={{ color: "info", component: "public" }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "New Signups", fontWeight: "bold" }}
                    count={data?.new_sign_up || 0}
                    percentage={{ color: "error", text: "" }}
                    icon={{ color: "info", component: "emoji_events" }}
                  />
                </SoftBox>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Pending Requests", fontWeight: "bold" }}
                    count={data?.pending_request || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{
                      color: "info",
                      component: "shopping_cart",
                    }}
                  />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "New Followers", fontWeight: "bold" }}
                    count={data?.followers || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "paid" }}
                  />
                </SoftBox>
                <MiniStatisticsCard
                  bgColor="white"
                  color="dark"
                  title={{ text: "New Reviews", fontWeight: "bold" }}
                  count={data?.reviews || 0}
                  percentage={{ color: "success", text: "" }}
                  icon={{ color: "info", component: "public" }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Claim Requests", fontWeight: "bold" }}
                    count={data?.claim_requests || 0}
                    percentage={{ color: "error", text: "" }}
                    icon={{ color: "info", component: "emoji_events" }}
                  />
                </SoftBox>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Premium Business", fontWeight: "bold" }}
                    count={data?.premium_businesses || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{
                      color: "info",
                      component: "shopping_cart",
                    }}
                  />
                </SoftBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default AgencyDashboard;
